import { FETCH_PRODUCT_SUCCESS } from 'Catalog/Product/ducks'
import { FETCH_SHOWCASE_SUCCESS } from 'Catalog/Showcase/ducks'
import { FETCH_SEARCH_SUCCESS } from 'Catalog/Search/ducks'

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_SUCCESS:
      var { vendor: { id: vendorId, logoUrl: imageUrl, ...rest } } = action.payload.data
      return {
        ...state,
        [vendorId]: {
          imageUrl,
          ...rest
        }
      }
    case FETCH_SHOWCASE_SUCCESS:
    case FETCH_SEARCH_SUCCESS:
      var hotVendors = action.payload.data.vendors.reduce((vendors, currentVendor) => {
        var { id: vendorId, quantity: _, ...rest } = currentVendor
        return {
          ...vendors,
          [vendorId]: rest
        }
      }, {})

      return { ...state, ...hotVendors }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Vendor/ducks.js